"use client";

import React, { createContext, useMemo, useState } from "react";

export type TableHoverContextType = {
  hoveredColIndex: number | null;
  hoveredRowIndex: number | null;
  setHoveredColIndex: (index: number | null) => void;
  setHoveredRowIndex: (index: number | null) => void;
};

export const TableHoverContext = createContext<TableHoverContextType | null>(
  null
);

export const TableHoverProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [hoveredColIndex, setHoveredColIndex] = useState<number | null>(
    null
  );
  const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(
    null
  );

  const value = useMemo(
    () => ({
      hoveredColIndex,
      hoveredRowIndex,
      setHoveredColIndex,
      setHoveredRowIndex,
    }),
    [hoveredColIndex, hoveredRowIndex]
  );

  return (
    <TableHoverContext.Provider value={value}>
      <div
        role="presentation"
        onMouseLeave={() => {
          setHoveredColIndex(null);
          setHoveredRowIndex(null);
        }}
      >
        {children}
      </div>
    </TableHoverContext.Provider>
  );
};
